import React from "react";
import {Switch as MuiSwitch} from "@mui/material";

const Switch = props => {
    const {className, children, ...other} = props;

    return (
        <MuiSwitch className={'ch-switch' + (className ? ' ' + className : '')} {...other}>
            {children}
        </MuiSwitch>
    )
}

export default Switch;